export default function withQueryParams(url, queryParams) {
  if (!queryParams) return url;
  const operand = url.indexOf('?') > -1 ? '&' : '?';
  const query = new URLSearchParams(queryParams);
  return query ? `${url}${operand}${query}` : url;
}
//# sourceMappingURL=withQueryParams.js.map